import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

import AlerterOnStart, { AlerterOnStartFace } from '../../components/Alerter/AlerterOnStart';
import { Button } from '../../components/MuiGenerals';
import { readAccessToken } from '../../utils/';
import { LOGIN_URL } from '../../utils/config';
import domainList from '../../utils/domainList/domainList';

export default function Login() {
  interface fieldsFace {
    appUuid: string;
  }
  const initFields = {
    appUuid: '',
  };

  const routerState = useLocation()?.state || {};
  const [fields, setFields] = useState<fieldsFace>(initFields);
  const { message, severity } = routerState as AlerterOnStartFace;

  const isLoggedIn = () => {
    const accessToken = readAccessToken();

    return accessToken && accessToken.length > 0;
  };

  useEffect(() => {
    console.log('domain list ', domainList);
    const domainInfo = domainList.find((d: any) => d.url === window.location.host);
    if (domainInfo) {
      setFields((fields) => ({ ...fields, appUuid: domainInfo.appUuid }));
    }
  }, []);

  const onSubmit = () => {
    if (isLoggedIn()) {
      window.location.replace('/');
    } else {
      const urlWithAppUuid = `${LOGIN_URL}?appUuid=${fields.appUuid}`;
      window.location.href = urlWithAppUuid || '';
    }
  };

  const disableLogin = fields.appUuid.length === 0;
  return (
    <div
      style={{
        width: '100vw',
        height: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        background: '#ffffff',
        overflow: 'hidden',
      }}
    >
      <Button variant="contained" onClick={onSubmit} disabled={disableLogin}>
        Login
      </Button>
      <AlerterOnStart message={message} severity={severity} />
    </div>
  );
}
